import { useGetApprovalAttachmentsQuery } from 'features/comments/approvalApi';
import HelperFunctions from 'pages/global/HelperFunctions';

/**
 * @param {string} uri
 * @returns {{items: import('../../../models/approval.models').ApprovalAttachment[]}}
 */
export function useGetApprovalAttachments(uri) {
    return useGetApprovalAttachmentsQuery(uri, {
        selectFromResult: (result) => HelperFunctions.queryResult(result),
    });
}
